import { useEditorContext } from '../contexts/editor';
import { useEditorEventHandler } from './useEditorEventHandler';
import { processTokensInDocument } from '../utils/processTokensInDocument';
import { useTokensFeaturePreview } from './useTokensFeaturePreview';

export const useTokensChangeHandler = () => {
  const { editor } = useEditorContext();
  const isTokensFeatureEnabled = useTokensFeaturePreview();

  useEditorEventHandler(['SetContent'], () => {
    if (editor && isTokensFeatureEnabled) {
      const bookmark = editor.selection.getBookmark();
      processTokensInDocument(editor.dom.doc);
      editor.selection.moveToBookmark(bookmark);
    }
  });
};
